import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import CnraclIrcantecAffiliation from "./CnraclIrcantecAffiliation";
import Id from "./Id";
import ProofOfAddress from "./ProofOfAddress";
import SocialSecurityCertificate from "./SocialSecurityCertificate";
import TerritorialCollectivityAttestation from "./TerritorialCollectivityAttestation";

const generateProofForm = ({
  isTNS,
  acceptTeletransmission,
  isRetired,
  isCommunityDocumentRequired,
  requiresTerritorialCollectivityAttestation,
  requiresCnraclIrcantecAffiliation,
}) => ({
  // Social Security Certificate - includes adherent, spouse, and children attestations
  [SUBSCRIPTION_FORM_KEYS.PROOF.SOCIAL_SECURITY_CERTIFICATE]:
    acceptTeletransmission && SocialSecurityCertificate,

  // ID documents - always required (logic handled internally based on payment conditions)
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,

  // Bank Account - includes single RIB or dual RIBs based on payment conditions
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,

  // Proof of Address - always required
  [SUBSCRIPTION_FORM_KEYS.PROOF.PROOF_OF_ADDRESS]: ProofOfAddress,

  // Territorial Collectivity Attestation - required when "En activité" AND profession is public service
  [SUBSCRIPTION_FORM_KEYS.PROOF.TERRITORIAL_COLLECTIVITY_ATTESTATION]:
    requiresTerritorialCollectivityAttestation &&
    TerritorialCollectivityAttestation,

  // CNRACL/IRCANTEC Affiliation - required when "Retraité" AND profession is public service
  [SUBSCRIPTION_FORM_KEYS.PROOF.CNRACL_IRCANTEC_AFFILIATION]:
    requiresCnraclIrcantecAffiliation && CnraclIrcantecAffiliation,
});

export default generateProofForm;
